var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobiliwebiconfinal101(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #70a4bf;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-3 {\n        fill: none;\n        stroke: #05465d;\n        stroke-miterlimit: 10;\n        stroke-width: 3px;\n      }\n\n      .cls-2 {\n        fill: #a12a41;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M117.11,138.399l.74-37.55c.21-21.34-15.43-38.83-35.17-39.67l.69-35.03-.08-.39c5.7-1.31,11.65-1.97,17.75-1.91,41.88.41,75.49,34.7,75.08,76.58-.36,36.03-25.79,65.94-59.55,73.32l-.15-.73.69-34.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82.68,61.179l-.74,37.15c-.21,21.9,15.5,39.8,35.17,40.07l-.69,34.62.15.73c-5.48,1.2-11.18,1.81-17.03,1.75-41.88-.41-75.5-34.7-75.08-76.58.35-35.77,25.43-65.51,58.83-73.16l.08.39-.69,35.03Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M83.29,25.759c5.7-1.31,11.65-1.97,17.75-1.91,41.88.41,75.49,34.7,75.08,76.58-.36,36.03-25.79,65.94-59.55,73.32-5.48,1.2-11.18,1.81-17.03,1.75-41.88-.41-75.5-34.7-75.08-76.58.35-35.77,25.43-65.51,58.83-73.16Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "83.37 26.149 82.68 61.179 81.94 98.329"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "117.85 100.849 117.11 138.399 116.42 173.019"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M81.94,98.329c-.21,21.9,15.5,39.8,35.17,40.07h.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M117.85,100.849c.21-21.34-15.43-38.83-35.17-39.67-.37-.02-.75-.03-1.12-.03"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobiliwebiconfinal101);
export default __webpack_public_path__ + "static/media/Mobili web icon final 1-01.3067ea258fe341f937c82974b030306e.svg";
export { ForwardRef as ReactComponent };